import { Sans } from "../util/sdk";

export async function reportErrorToNR(error: string | Error, meta: Record<string, unknown> = {}) {
  let userId: string | null | undefined;
  try {
    userId = await Sans.sdk.getUserId();
  } catch (userIdError) {
    console.warn("Failed to get user ID for New Relic error reporting", userIdError);
  }
  const newrelic = (globalThis as { newrelic?: { noticeError: (error: unknown, meta?: object) => void } }).newrelic;
  if (newrelic) {
    console.log("Sending error:", error, meta, userId);
    newrelic.noticeError(error, { ...meta, userId });
  }
}
